exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Social__SocialItem__3uSAm {\n    display: flex;\n    align-items: center;\n}\n\n.Social__SocialItem__3uSAm svg {\n    width: 16px;\n    fill: white;\n    margin-right: 0.5em;\n}", ""]);

// Exports
exports.locals = {
	"SocialItem": "Social__SocialItem__3uSAm"
};